import { memo, ReactNode } from 'react'

import { Chip, Paper, Stack, Typography } from '@mui/material'
import { AvcTaskAssociation } from '@nativewaves/nw-cloud-sdk/content'
import { useTranslation } from 'react-i18next'

import { AssociationRow, useAvcTaskAssociationRows } from 'domains/Workspaces/Streams/AvcTaskAssociations'

export type SectionProps = {
  associations: AvcTaskAssociation[]
  /** Wraps each row in a link to its AVC task. Supplied per stream kind, since the routes differ. */
  TaskLink: (taskId: string, content: ReactNode) => ReactNode
}

const SectionRaw = ({ associations, TaskLink }: SectionProps) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])

  const rows = useAvcTaskAssociationRows(associations)

  return (
    <Paper sx={{ px: 4, py: 3 }} elevation={0}>
      <Typography sx={{ mb: 1 }} variant="heading-md">
        {t('entity:content.avcTask', { count: 2 })}
      </Typography>

      {rows.length ? (
        <Stack sx={{ rowGap: 1 }}>
          {rows.map((row) =>
            TaskLink(
              row.taskId,
              <AssociationRow
                interactive
                row={row}
                EnabledSlot={
                  <Chip
                    size="small"
                    variant="outlined"
                    color={row.enabled ? 'success' : 'default'}
                    label={
                      row.enabled
                        ? t('domain:Workspace.AvcTaskAssociations.enabled')
                        : t('domain:Workspace.AvcTaskAssociations.disabled')
                    }
                  />
                }
              />,
            ),
          )}
        </Stack>
      ) : (
        <Typography sx={{ py: 2, display: 'block', color: 'text.secondary' }} variant="text-sm">
          {t('domain:Workspace.AvcTaskAssociations.none')}
        </Typography>
      )}
    </Paper>
  )
}

export const Section = memo(SectionRaw)
